import ButtonGroup from '@jetbrains/ring-ui/components/button-group/button-group'
import React from 'react'

import {useBooleanQueryParam} from '../../../../../../hooks/routes'
import {objectToQuery} from '../../../../../../utils/queryParams'
import ButtonLink from '../../../components/common/ButtonLink/ButtonLink'
import {usePipelineId} from '../../../hooks/pipeline'
import useSaveChangesError from '../../EditPipelineHeader/SaveChanges/hooks/useSaveChangesError'
import {useEditPipelineYAML} from '../../EditPipelinePage.hooks'

import styles from './EditPipelineToggle.css'

function EditPipelineToggle() {
  const pipelineId = usePipelineId()
  const isYaml = useBooleanQueryParam('yaml')
  const {hasErrors} = useSaveChangesError(pipelineId)

  const editPipelineYAML = useEditPipelineYAML()

  return (
    <ButtonGroup className={styles.buttonGroup}>
      <ButtonLink
        to={{search: objectToQuery({yaml: 'false'})}}
        active={!isYaml}
        disabled={hasErrors || !editPipelineYAML.isValid}
      >
        {'Visual'}
      </ButtonLink>
      <ButtonLink
        to={{search: objectToQuery({yaml: 'true'})}}
        active={isYaml}
        disabled={hasErrors || !editPipelineYAML.isValid}
      >
        {'YAML'}
      </ButtonLink>
    </ButtonGroup>
  )
}

export default EditPipelineToggle
